__turbopack_context__.v({
  "arrow": "Arrow-module-sass-module__-pZHFa__arrow",
  "diagonal": "Arrow-module-sass-module__-pZHFa__diagonal",
  "horizontal": "Arrow-module-sass-module__-pZHFa__horizontal",
});
